import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/biweekly-loan-calculator',
  component: () => import('../../routes/BiweeklyLoanCalculator.svelte'),
  card: {
    id: 'biweekly-loan-calculator',
    title: 'Biweekly Loan Calculator',
    description: 'Compare monthly vs biweekly loan payments to see how biweekly payments save interest and pay off your loan faster.',
    icon: 'calendar_sync',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/biweekly-loan-calculator',
    category: 'Loans & Debt',
  },
  seo: {
    title: 'Biweekly Loan Calculator – Compare Monthly vs Biweekly Payments',
    description: 'Free biweekly loan calculator shows how making payments every two weeks instead of monthly saves thousands in interest and shortens your loan term.',
  },
};

export default meta;
